import { render, staticRenderFns } from "./myWallet.vue?vue&type=template&id=46ca2e22&scoped=true"
import script from "./myWallet.vue?vue&type=script&lang=js"
export * from "./myWallet.vue?vue&type=script&lang=js"
import style0 from "./myWallet.vue?vue&type=style&index=0&id=46ca2e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ca2e22",
  null
  
)

export default component.exports